
import React, { Component } from 'react';


const RoutemapNoGPSAction = (props) => {
    const handleClick = (e) => {
        e.stopPropagation();
        //console.log("Props ", props);
        props.agGridReact.props.gridOptions.context.componentParent.onShowNoGPSRouteMap(props.data);
    };

    return (
        <div>
            {(props.data.packet_received_on)?
            <button onClick={handleClick} className="custom-btn label label-success"><i className="icofont icofont-map-pins f20"></i> </button>
       
        :""}
			
        </div>
    );
};

export default RoutemapNoGPSAction;
